import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeader } from "./SectionHeader";

const FAQS = [
    {
        q: "Does remembered.sh work with my agent?",
        a: "Claude Code, Codex, Cursor, and OpenCode have curated tool registries. Any other harness sends one JSON trace to POST /v1/extract, and a read-only MCP server exposes five tools.",
    },
    {
        q: "How does procedural graph memory differ from vector search?",
        a: "Vector search returns chunks of text. remembered.sh stores procedures: steps with a precondition, a postcondition, and the outcome that decided whether the run passed. The step parse is deterministic — the same trace gives the same steps.",
    },
    {
        q: "Is data stored locally, self-hosted, or cloud-managed?",
        a: "Procedures live in your own store: a local file, your own database, or your Postgres. Only the prompt and allow-listed tool arguments leave the machine.",
    },
    {
        q: "What is the latency overhead on agent inference calls?",
        a: "Recall adds about 60 milliseconds to a prompt. Three matchers run in order: exact, then lexical, then semantic on a miss.",
    },
    {
        q: "Can we inspect and visualize the agent memory graph?",
        a: "The dashboard shows every stored procedure: steps, preconditions, postconditions, and the time, tokens, and money spent on each run.",
    },
];

const Faq = () => (
    <section id="faq" data-testid="faq-section" className="border-t border-[#262626]">
        <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
            <SectionHeader id="faq">Frequently Asked Questions</SectionHeader>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                {FAQS.map((item, i) => (
                    <AccordionItem
                        key={i}
                        value={`faq-${i}`}
                        className="border-[#262626]"
                        data-testid={`faq-item-${i}`}
                    >
                        <AccordionTrigger
                            data-testid={`faq-trigger-${i}`}
                            className="text-left text-base font-medium text-neutral-100 hover:text-green-400 hover:no-underline sm:text-lg"
                        >
                            {item.q}
                        </AccordionTrigger>
                        <AccordionContent
                            data-testid={`faq-content-${i}`}
                            className="text-sm leading-relaxed text-neutral-400"
                        >
                            {item.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    </section>
);

export default Faq;
